<template lang="pug">
  .people-page
    .peoples
      //- pre {{ models }}
      router-link.people(v-for="(model, key) in models", :key="key", :to="{ name: 'project-detail', params: { id: model._id }}")
        f-storage-image.image(:path="model.properties.thumbnailPath + '_s_256_____thumb.png'")
        span.name
          span {{ model.properties.name }}
    infinite-loading(v-if="!isCallFirstLoad", @infinite='infiniteHandler')
</template>

<script>
import Node from '@/models/node'
import FStorageImage from '@/components/FStorageImage'
import InfiniteLoading from 'vue-infinite-loading'
export default {
  components: {
    InfiniteLoading,
    FStorageImage
  },
  data () {
    return {
      page: 1,
      isCallFirstLoad: true,
      models: []
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      Node.getAll('Project', { page: this.page, limit: 30, keyword: '' })
        .then((models) => {
          this.models = models
          this.isCallFirstLoad = false
        })
    },
    infiniteHandler ($state) {
      Node.getAll('Project', { page: this.page, limit: 30, keyword: '' })
        .then((models) => {
          if (models && models.length > 0) {
            this.models = this.models.concat(models)
            this.page = this.page + 1
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    }
  }
}
</script>

<style lang="scss">
.peoples {
  display: flex;
  flex-wrap: wrap;
  .people {
    flex: 0 0 20%;
    position: relative;
    .image  {
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);
      display: block;
    }
    .name {
      position: absolute;
      height: 100%;
      width: 100%;
      padding: 15px;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #ddd;
      font-size: 24px;
      span {
        text-align: center;
      }
    }
  }
  .people:hover {
    .name {
    }
    .image  {
      -webkit-filter: none; /* Safari 6.0 - 9.0 */
      filter: none;
    }
  }
}
@media only screen and (max-width: 1024px) {
  .peoples {
    .people {
      flex: 0 0 25%;
    }
  }
}
@media only screen and (max-width: 600px) {
  .peoples {
    .people {
      flex: 0 0 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/project/Index.vue